module.exports = __webpack_public_path__ + "static/media/no-stores.262139c6.svg";